<template>
  <label :class="`bundle bundle-${color}`">
    {{ $t(`mailer.message.status_table.${value}`) }}
  </label>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function () {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'sent': {
            return 'blue';
          }
          case 'pending': {
            return 'fresh';
          }
          case 'delivered': {
            return 'green';
          }
          case 'active': {
            return 'green';
          }
          case 'not_delivered': {
            return 'yellow';
          }
          case 'failed': {
            return 'error';
          }
          case 'error': {
            return 'error';
          }
          case 'rejected': {
            return 'orange';
          }
          case 'processing': {
            return 'orange';
          }
          case 'resending': {
            return 'pink';
          }
          case 'expired': {
            return 'yellow';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>
